import { SignUp } from "../../Components/Login&SignUp/SignUp";

const SignUpPage = () => {
  return (
    <div>
      <SignUp />
    </div>
  );
};

export default SignUpPage;
